import { render, staticRenderFns } from "./Salidas.vue?vue&type=template&id=1730e62d&"
import script from "./Salidas.vue?vue&type=script&lang=js&"
export * from "./Salidas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports